const HEART_BEAT_CONFIG = {
  time: 10 * 1000, // 心跳时间间隔
  timeout: 10 * 1000, // 心跳超时间隔
};

/**
 * 心跳机制处理类
 */
export default class HeartBeat {
  constructor(startCallBack, waitCallBack, config = HEART_BEAT_CONFIG) {
    this.isHeartReply = false;
    this.heartBeatFunc = null;
    this.heartBeatCheckFunc = null;

    this.startCallBack = startCallBack;
    this.waitCallBack = waitCallBack;

    this.config = config;
  }

  startHeartBeat() {
    this.resetHeartBeat();
    this.heartBeatFunc = setTimeout(() => {
      this.startCallBack && this.startCallBack();
      this.waitingServer();
    }, HEART_BEAT_CONFIG.time);
  }

  //延时等待服务端响应，通过webSocketState判断是否连线成功
  waitingServer() {
    this.isHeartReply = false;
    this.heartBeatCheckFunc = setTimeout(
      this.waitCallBack ? this.waitCallBack : () => {},
      HEART_BEAT_CONFIG.timeout
    );
  }

  // 重置心跳定时器函数
  resetHeartBeat() {
    clearTimeout(this.heartBeatFunc);
    clearTimeout(this.heartBeatCheckFunc);
  }

  changeHeartBeat(val) {
    this.isHeartReply = !!val;
  }

  stopHeartBeat() {
    this.resetHeartBeat();
    this.isHeartReply = false;
  }
}
